<script>
    import R, {LOADER} from "../lib/requests";
    import {flip} from 'svelte/animate';
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {copyObjectProperties, sort} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import OfferEditModal from "./OfferEditModal.svelte";


    let offers = null;
    let offerId = null;
    let editOfferId = null;
    let hovering = false;

    const pageHeaderControls = [
        {id: 'create', name: 'CREATE OFFER', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'NAME'},
        {key: 'title', title: 'TITLE'},
        {key: 'is_best', title: 'BEST'},
        {key: 'department_count', title: 'DEPTs'},
        {key: '', title: ''},
    ];

    const load = () => {
        const onSuccess = result => {
            offers = result;
        }

        const onFailure = err => {
        };

        R.handle(R.offer.index, {}, onSuccess, onFailure, LOADER.PAGE);
    }

    const saveViewOrder = () => {
        const onSuccess = result => {
            Notifier.showMessage("View order saved");
        }

        const onFailure = err => {
        };

        let order = offers.map(item => (item.id));

        R.handle(R.offer.editOrder, order, onSuccess, onFailure, LOADER.PAGE);
    }

    const onCreate = () => {
        editOfferId = 0;
    }

    const onEdit = (offer) => {
        offerId = offer.id;
        editOfferId = offer.id;
    }

    const closeEdit = (offer) => {
        console.log("closeEdit", offer);
        if (offer) {
            offer.department_count = offer?.department_ids?.length ?? 0;
            let properties = ['id', 'name', 'title', 'is_best', 'is_active', 'department_count'];

            let item = offers.find(x => x.id == offer.id);
            if (item) {
                copyObjectProperties(offer, item, properties);
                offers = offers;
            } else {
                offers = [copyObjectProperties(offer, properties), ...offers];
            }
        }
        editOfferId = null;
    }

    const onDelete = (offer) => {
        Alert.delete("Delete offer", `This will permanently delete offer "${offer.name}".\nAre you sure?`, () => deleteOffer(offer.id));
    }

    const deleteOffer = id => {
        const onSuccess = result => {
            offers = offers.filter(x => x.id != result);
            Notifier.showMessage("Offer deleted");
        }

        const onFailure = err => {
            if (err.code === 'not_allowed') {
                Alert.warning("Delete offer", `You are not allowed to delete this offer!`);
                return;
            }

            if (err.code === 'object_related') {
                let message = [];
                Object.keys(err.params).map(key => {
                    if (err.params[key] > 0) {
                        message.push(`${err.params[key]} ${key}`);
                    }
                });
                Alert.warning("Delete offer", `Offer is related to ${message.join(", ")}.\nYou can not delete this offer.`);
            }
        };

        R.handle(R.offer.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const dragstart = (event, i) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.dropEffect = 'move';
        event.dataTransfer.setData('text/plain', i);
    }

    const drop = (event, target) => {
        event.dataTransfer.dropEffect = 'move';
        const start = parseInt(event.dataTransfer.getData("text/plain"));
        const newTracklist = offers;

        if (start < target) {
            newTracklist.splice(target + 1, 0, newTracklist[start]);
            newTracklist.splice(start, 1);
        } else {
            newTracklist.splice(target, 0, newTracklist[start]);
            newTracklist.splice(start + 1, 1);
        }
        offers = newTracklist;
        hovering = null;
        saveViewOrder();
    }

    load();
</script>

<PageHeader title="Offers" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

{#if offers}
    <div class="panel">
        <div class="panel-body">
            {#if offers.length}
                <table class="table table-list table-list-border">
                    <TableHeader {tableColumns}/>
                    <tbody>
                    {#each offers as item, index (item.id)}
                        <tr class="row-hover" class:row-selected={offerId === item.id}
                            animate:flip="{{ duration: 100 }}"
                            draggable={true}
                            on:dragstart={event => dragstart(event, index)}
                            on:drop|preventDefault={event => drop(event, index)}
                            ondragover="return false"
                            on:dragenter={() => hovering = index}
                            class:drag-over={hovering === index}
                        >
                            <td>
                                <button class="btn-reset is-link text-start" class:not-active={item.is_active < 1}
                                        on:click={() => onEdit(item)}>
                                    {item.name}
                                </button>
                            </td>
                            <td>
                                {item.title}
                            </td>
                            <td class="text-gray button-column">
                                {#if item.is_best == 1}
                                    ✓
                                {/if}
                            </td>
                            <td class="text-gray button-column text-center">
                                {item.department_count}
                            </td>
                            <td class="button-column" title="delete user">
                                <button class="btn-reset btn-tool" title="delete offer" on:click={() => onDelete(item)}>
                                    <AppIcon icon="trash" size="16"/>
                                </button>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {/if}
        </div>
    </div>
{/if}
{#if editOfferId != null}
    <OfferEditModal offerId="{ editOfferId }" closeCallback="{ closeEdit }"/>
{/if}